export default __webpack_public_path__ + "static/media/faq_tutorials.e96d24e4.png";